var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.724C0 5.57317 4.98625 0.586914 11.1371 0.586914C17.288 0.586914 22.2742 5.57317 22.2742 11.724C22.2742 17.8749 17.288 22.8611 11.1371 22.8611C4.98625 22.8611 0 17.8749 0 11.724Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09864 7.69852C8.0985 7.99319 7.98781 8.27573 7.79093 8.48399C7.59404 8.69225 7.32709 8.80916 7.04879 8.80901C6.7705 8.80887 6.50365 8.69167 6.30697 8.4832C6.11028 8.27473 5.99986 7.99208 6 7.69741C6.00014 7.40274 6.11083 7.1202 6.30771 6.91194C6.50459 6.70368 6.77155 6.58677 7.04984 6.58691C7.32814 6.58706 7.59498 6.70426 7.79167 6.91273C7.98836 7.12119 8.09878 7.40385 8.09864 7.69852ZM8.13012 9.63174H6.03148V16.5869H8.13012V9.63174ZM11.446 9.63174H9.35782V16.5869H11.425V12.9371C11.425 10.9039 13.9276 10.715 13.9276 12.9371V16.5869H16V12.1816C16 8.75402 12.2959 8.88179 11.425 10.565L11.446 9.63174Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.9df3fb619ca46ce45010a48980be3bc0.svg";
export { ForwardRef as ReactComponent };